import React from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ListSectionTemplate from "../../common/ListSectionTemplate";
import { useProfile, isOwner } from "../../../context/ProfileContext";
import { useStudioTours } from "../../../reacttour/StudioTourContext";
import { TOUR_LABELS } from "../../../reacttour/StudioTours";
import { replayTours } from "../../../api/studioAPI";
import { listPlans } from "../../../game-builder/api/gameBuilderAPI";
import { colors, surfaces, buttons } from "../../../styles/index";

const WHERE = {
  welcome: "Starts on your first visit.",
  "new-plan": "Starts the first time you open ＋ New plan in My Simulations.",
  "path-review": "Starts the first time you review a mission's design.",
};

// Which walkthroughs this person has finished, and a way to see them again.
export default function WalkthroughsPanel() {
  const navigate = useNavigate();
  const { profile, setToursDone } = useProfile();
  const { startTour } = useStudioTours();
  const done = profile?.tours_done || [];

  const replayAll = async () => {
    try {
      await replayTours();
      setToursDone([]);
      toast.success("Each walkthrough will start again the next time you reach it.");
    } catch (e) {
      toast.error(e.message);
    }
  };
  const startWelcome = async () => {
    navigate("/app/dashboard");
    const hasPlans = await listPlans().then((d) => d.plans.length > 0).catch(() => false);
    startTour("welcome", { hasPlans, isDemo: !!profile?.org?.is_demo, isOwner: isOwner(profile) });
  };

  return (
    <ListSectionTemplate title="Walkthroughs" actions={<button type="button" style={buttons.secondary} onClick={replayAll}>Show them all again</button>}>
      <div style={{ ...surfaces.card, textAlign: "left", padding: 0 }}>
        {Object.entries(TOUR_LABELS).map(([key, label]) => (
          <div key={key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px",
            borderBottom: `1px solid ${colors.border}`, flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 240px" }}>
              <strong>{label}</strong>
              <div style={{ fontSize: "0.85rem", color: colors.textMuted }}>{WHERE[key]}</div>
            </div>
            <span style={{ fontSize: "0.85rem", color: done.includes(key) ? colors.accent : colors.textMuted }}>
              {done.includes(key) ? "Seen" : "Not seen yet"}
            </span>
            {key === "welcome" && (
              <button type="button" style={{ ...buttons.secondary, minHeight: 36, padding: "6px 12px" }} onClick={startWelcome}>Start</button>
            )}
          </div>
        ))}
      </div>
    </ListSectionTemplate>
  );
}
